import axios from 'axios';

import { setupInterceptors } from './interceptors';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BrokerServerUrl}/${process.env.REACT_APP_BrokerServerEndpoint}`,
});

setupInterceptors(axiosInstance);

export default axiosInstance;
